export const THROBBER_TXT = [
	'Retrieving your data...',
	'Large data calls take a little longer...',
	'Retrieving your data...',
	'We are working on it...',
];
